export const HIDE_CHECKOUT_PROFILE_STORECONF_KEY = 'HIDE_CHECKOUT_PROFILE';

/** Checkout profiles are hidden only when the storeconf is explicitly set to 'true'. */
export const isCheckoutProfileHidden = (userData: Record<string, string> | undefined): boolean =>
	userData?.[HIDE_CHECKOUT_PROFILE_STORECONF_KEY]?.trim().toLowerCase() === 'true';
